module.exports = __webpack_public_path__ + "media/images/flags/1x1/mlt-93f37492cc47be26a87eccf70e91cac1.svg";